import { FC, SVGAttributes } from 'react';

const TickCircle: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 2.75C17.1109 2.75 21.25 6.88908 21.25 12C21.25 17.1109 17.1109 21.25 12 21.25C6.88908 21.25 2.75 17.1109 2.75 12C2.75 6.88908 6.88908 2.75 12 2.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.07 12L10.69 14.62L15.93 9.38"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TickCircle;
